import { Tooltip } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { IoArrowRedoOutline } from "react-icons/io5";

import { Button, IconButton } from "../../../components";
import {
  AiInterviewerFragment,
  AiInterviewerListItemFragment,
} from "../../graphql";
import {
  REQUIRES_BH_SCREEN_MANAGE_PERMISSION,
  useBHScreenPermission,
} from "../../hooks/useBHScreenPermission";
import { ShareModalV2 } from "../ShareModalV2";
import { useAiInterviewerShareModalV2 } from "./useAiInterviewerShareModalV2";

interface ShareAiInterviewerButtonProps {
  aiInterviewer: AiInterviewerFragment | AiInterviewerListItemFragment;
  iconOnly?: boolean;
  ghost?: boolean;
}

const ShareAiInterviewerButton: React.FC<ShareAiInterviewerButtonProps> = ({
  aiInterviewer,
  iconOnly = false,
  ghost = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { canManage } = useBHScreenPermission(aiInterviewer);

  const { shareModalProps, loadData } = useAiInterviewerShareModalV2({
    aiInterviewerId: aiInterviewer.id,
    onClose: () => setIsOpen(false),
  });

  // Load data when modal opens
  useEffect(() => {
    if (isOpen) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const disabledReason = !canManage
    ? REQUIRES_BH_SCREEN_MANAGE_PERMISSION
    : undefined;

  return (
    <>
      {iconOnly ? (
        <Tooltip label={disabledReason || "Share"}>
          <IconButton
            aria-label="Share"
            icon={<IoArrowRedoOutline />}
            variant="ghost"
            size="sm"
            color="gray.900"
            _hover={
              !disabledReason ? { color: "blue.500", bg: "blue.50" } : undefined
            }
            onClick={() => setIsOpen(true)}
            isDisabled={!!disabledReason}
          />
        </Tooltip>
      ) : (
        <Button
          variant={ghost ? "ghost" : "default"}
          size="xs"
          leftIcon={<IoArrowRedoOutline />}
          onClick={() => setIsOpen(true)}
          isDisabled={!!disabledReason}
        >
          Share
        </Button>
      )}

      <ShareModalV2
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        {...shareModalProps}
      />
    </>
  );
};

export { ShareAiInterviewerButton };
